<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top" class="auto-form">
            <div class="topic-option">
                <el-form-item :label="$t('paper.difficultDistribution')+'：'" prop="checkList" style="margin-right: 100px">
                        <el-checkbox-group v-model="ruleForm.checkList" @change="selectLevelChange(1,ruleForm.checkList)">
                            <el-checkbox-button :label="1">{{$t('paper.simple')}}</el-checkbox-button>
                            <el-checkbox-button :label="2">{{$t('paper.medium')}}</el-checkbox-button>
                            <el-checkbox-button :label="3">{{$t('paper.hard')}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                <el-form-item :label="$t('paper.topicSource')+'：'" prop="isOnlyMine"  style="margin-right: 100px">
                    <el-select v-model="ruleForm.isOnlyMine" ref="fileTree" placeholder="$t('tip.select')" @change="selectLevelChange(2,ruleForm.isOnlyMine)">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('paper.scorePerQuestion')" prop="topicScore">
                        <el-input-number v-model="ruleForm.topicScore" controls-position="right" :min="1"></el-input-number>
                    </el-form-item>

            </div>
            <el-form-item :label="$t('paper.knowledgeTotalNum', [kpTotalNum])" class="topic-type" prop="hours">
                {{$t('paper.questionQuantity')}}&ensp;
                <el-input-number v-model="ruleForm.kpNum" controls-position="right" size="mini" :min="0" :max="kpTotalNum"></el-input-number>
                &ensp;{{$t('paper.dao')}}
                <p>
                    {{$t('c.total')}}&ensp;
                    <el-input-number :value="ruleForm.kpNum*ruleForm.topicScore" controls-position="right"
                                     size="mini"
                                     disabled>
                    </el-input-number>
                    &ensp;{{$t('paper.points')}}
                </p>
            </el-form-item>
            <el-form-item :label="$t('paper.emptyPacketTotalNum', [emptyTotalNum])" class="topic-type" prop="hours">
                {{$t('paper.questionQuantity')}}&ensp;
                <el-input-number v-model="ruleForm.emptyNum" controls-position="right" size="mini" :min="0" :max="emptyTotalNum"></el-input-number>
                &ensp;{{$t('paper.dao')}}
                <p>
                    {{$t('c.total')}}&ensp;
                    <el-input-number :value="ruleForm.emptyNum*ruleForm.topicScore" controls-position="right" size="mini" disabled></el-input-number>
                    &ensp;{{$t('paper.points')}}
                </p>
            </el-form-item>

            <el-form-item :label="$t('paper.otherTotalNum', [otherTotalNum])" class="topic-type" prop="hours">
                {{$t('paper.questionQuantity')}}&ensp;
                <el-input-number v-model="ruleForm.otherNum" controls-position="right" size="mini" :min="0" :max="otherTotalNum"></el-input-number>
                &ensp;{{$t('paper.dao')}}
                <p>
                    {{$t('c.total')}}&ensp;
                    <el-input-number :value="ruleForm.otherNum*ruleForm.topicScore" controls-position="right" size="mini" disabled></el-input-number>
                    &ensp;{{$t('paper.points')}}
                </p>

            </el-form-item>

            <div class="count">
                <p>
                    {{$t('paper.totalQuestions')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="totalQuestions"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.dao')}}
                </p>
                <p>
                    {{$t('paper.paperScore')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="paperScore"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.points')}}
                </p>
                <p>
                    {{$t('paper.passingMark')}}&ensp;
                    <el-input style="width:130px;margin-top: 20px"
                              :value="passScore"
                              size="mini" disabled>
                    </el-input>
                    &ensp;{{$t('paper.points')}}
                </p>
            </div>
        </el-form>
        <div class="btn-group">
            <el-button type="primary" @click="finishStep" style="padding: 14px 50px;font-size: 18px;">{{$t('paper.savePaper')}}</el-button>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api';
    export default {
        props: ['passLine','paperName','pattern','type','knowledgeName','forLevel','difficulty'],
        data() {
            return {
                ruleForm:{
                    checkList:[2],
                    kpNum:0,
                    emptyNum:0,
                    otherNum:0,
                    topicScore:2,
                    totalNum:0,
                    totalScore:0,
                    passScore:0,
                    isOnlyMine:true
                },
                options: [{
                    value: false,
                    label: this.$t('topic.examPaperLibrary')
                }, {
                    value: true,
                    label: this.$t('topic.myTopic')
                }],
                kpTotalNum:0,
                emptyTotalNum:0,
                otherTotalNum:0,
                rules:{
//                    checkList:{ required: true, message: this.$t('tip.difficulty'), trigger: 'change' },
                    topicScore:{required: true, message: this.$t('tip.questionScore'), trigger: 'change' },

                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
            }
        },
        created() {
            let submitData = {
                difficulties: this.ruleForm.checkList,
                knowledge: this.knowledgeName[this.knowledgeName.length-1],
                isOnlyMine: this.ruleForm.isOnlyMine,
            };
            if(this.type==3){
                api.getCTTopicStock(submitData).then(res => {
                    this.kpTotalNum=res.package[0]
                    this.emptyTotalNum=res.package[1]
                    this.otherTotalNum=res.package[2]
                });
            }else{
                api.getDRTopicStock(submitData).then(res => {
                    this.kpTotalNum=res.package[0]
                    this.emptyTotalNum=res.package[1]
                    this.otherTotalNum=res.package[2]
                });
            }
        },
        computed: {
            ...mapGetters([
                'knowledgeMenu',
            ]),
            totalQuestions() {
                return (this.ruleForm.kpNum||0) + (this.ruleForm.emptyNum||0) + (this.ruleForm.otherNum||0);
            },
            paperScore() {
                return this.ruleForm.topicScore * this.totalQuestions;
            },
            passScore() {
                return (this.paperScore*this.passLine).toFixed(1);
            },
        },
        methods: {
            selectLevelChange(type,value) {
                let submitData = {
                    difficulties: type==1?value:this.ruleForm.checkList,
                    knowledge: this.knowledgeName[this.knowledgeName.length-1],
                    isOnlyMine: type==2?value:this.ruleForm.isOnlyMine,
                };
                if(this.type==3){
                    api.getCTTopicStock(submitData).then(res => {
                        this.kpTotalNum=res.package[0]
                        this.emptyTotalNum=res.package[1]
                        this.otherTotalNum=res.package[2]
                    });
                }else{
                    api.getDRTopicStock(submitData).then(res => {
                        this.kpTotalNum=res.package[0]
                        this.emptyTotalNum=res.package[1]
                        this.otherTotalNum=res.package[2]
                    });
                }


            },
            //知识点变化
            knowledgeChange(data){
                this.ruleForm.knowledge=data;
            },
            lastStep() {
                this.$emit('last-step');
            },
            finishStep() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
//                        if (!this.ruleForm.kpNum) {
//                            this.$message(this.$t('paper.paperNeddIncludeOneKP'));
//                            return;
//                        }
                        let submitData = {
                            topicDifficulties: this.ruleForm.checkList,
                            topicScore:this.ruleForm.topicScore,
                            difficulty: this.difficulty,
                            title: this.paperName,
                            forLevel: this.forLevel,
                            knowledge: this.knowledgeName[this.knowledgeName.length-1],
                            passLine: this.passLine,
                            type: this.type,
                            form: this.pattern,
                            safeCount: this.ruleForm.emptyNum,
                            otherCount: this.ruleForm.otherNum,
                            coreCount: this.ruleForm.kpNum,
                            isOnlyMine: this.ruleForm.isOnlyMine,
                        };
                        api.imagePaperAutomatic(submitData).then(res => {
                            this.$notify({
                                title: res.error,
                                message: this.$t('paper.smartGroupSuccess')+'!',
                                type: 'success',
                                duration: 2000
                            });
                            this.$emit('needUpdate');
                            this.$router.replace({name: 'myPaper'})
                        });
                        // console.log(submitData);
                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        watch: {},
        components: {}
    }
</script>

<style scoped lang="scss">
    .auto-form {
        .topic-type {
            margin-bottom: 30px;
            .el-form-item__label {
                padding: 0 10px;
                margin-bottom: 10px;
                height: 28px;
                line-height: 28px;
                text-align: center;
                color: #fff;
                background-color: #2e7faa;
            }
        }

        .el-form-item {
            margin-bottom: 10px;
        }
    }

    .middle-line{
        background-color: #e3e6eb;
        border: 0;
        height: 1px;
        margin-top: 10px;
        margin-bottom: 30px;
    }
    .auto-form {
        color: #252525;

        .topic-type {
            p {
                display: inline-block;
                margin-left: 4.3%;
            }

            .el-cascader {
                margin-left: 4.3%;
            }
        }

        .count {
            > p {
                display: inline-block;
                margin-right: 84px;
            }
        }
    }
    .topic-option{
        display: flex;
        margin-bottom: 37px;
    }
    .btn-group {
        margin-top: 60px;
        margin-bottom: 15px;
    }
</style>
